import { Checkbox, FormControlLabel } from '@material-ui/core';
import { observer } from 'mobx-react';
import * as React from 'react';
import { _IEditProps } from './_IEditProps';

const readonlyInputProps = { readOnly: true, disabled: false };
const readwriteInputProps = { readOnly: false, disabled: false };

export const _BooleanEdit = observer(function _BooleanEdit(props: _IEditProps) {
	const {accessors, label, error, isRequired, isReadonly, className, classes} = props;
	const value = accessors.getter();
	return <FormControlLabel
		control={<Checkbox
			color={'default'}
			className={className}
			disabled={isReadonly}
			inputProps={isReadonly ? readonlyInputProps : readwriteInputProps}
			onChange={accessors.handleChange}
			checked={!!value}
		/>}
		label={label}
	/>;
});
